import anozieImage from "../assets/success-stories/Anozie.jpeg";
import madukweImage from "../assets/success-stories/MADUKWE CHINAZA HENRY.jpeg";
import nwachukwuImage from "../assets/success-stories/NWACHUKWU JOHN IFEANYI.jpeg";
import osinafaImage from "../assets/success-stories/Osinafa Echezonchukwu Jude.jpeg";
import uzokweImage from "../assets/success-stories/UZOKWE KINGSLEY ELOCHUKWU.jpeg";

const INFOFIT = "Infofit Software Solutions Pvt. Ltd.";
const AFRICAN_TECH = "African Tech Academy";
const FSD_INTERN = "Full Stack Developer Intern";

export const successStories = [
  {
    id: 1,
    name: "Nwachukwu John Ifeanyi",
    experiences: [
      { role: FSD_INTERN, company: INFOFIT },
      { role: "Fellow", company: AFRICAN_TECH },
    ],
    image: nwachukwuImage,
    imagePosition: "50% 22%",
  },
  {
    id: 2,
    name: "Madukwe Chinaza Henry",
    experiences: [{ role: FSD_INTERN, company: INFOFIT }],
    image: madukweImage,
    imagePosition: "50% 25%",
  },
  {
    id: 3,
    name: "Anozie",
    experiences: [{ role: FSD_INTERN, company: INFOFIT }],
    image: anozieImage,
    imagePosition: "50% 35%",
  },
  {
    id: 4,
    name: "Osinafa Echezonchukwu Jude",
    experiences: [{ role: FSD_INTERN, company: INFOFIT }],
    image: osinafaImage,
    imagePosition: "50% 24%",
  },
  {
    id: 5,
    name: "Uzokwe Kingsley Elochukwu",
    experiences: [{ role: FSD_INTERN, company: INFOFIT }],
    image: uzokweImage,
    imagePosition: "50% 23%",
  },
];
